import { useSite } from 'Shared/SiteProvider';
import {VenueSettingsFactory} from 'Shared/VenueSettingsFactory';
import { useVenue } from 'Shared/VenueProvider';
import { Wrap } from 'Shared/forms/Wrap';
import { StylesField } from 'Shared/backend/widgets/Styles';
import { createSignal, Show, Switch, Match } from 'solid-js';
import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';

export type { IAnimation, IStylesRule, StyleEntry, NestedStyles } from 'Shared/backend/styleUtils';
export { flattenStyles } from 'Shared/backend/styleUtils';


export function StyleTags()
{
	const outerStyle = () => css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'end',
		marginBottom: '0.7em'
	});

	const linkWrapStyle = () => css({
		display: 'flex',
	});

	const linkStyle = () => css(theme().a);

	const [show,setShow] = createSignal(false);

	return (
		<div class={outerStyle()}>
			<div class={linkWrapStyle()}>
				<Switch>
					<Match when={show()}>
						<a class={linkStyle()} href='' onClick={() => setShow(false)}>Hide styles</a>
					</Match>
					<Match when={true}>
						<a class={linkStyle()} href='' onClick={() => setShow(true)}>Show styles</a>
					</Match>
				</Switch>
			</div>

			<Show when={show()}>
				<StyleTagContents />
			</Show>
		</div>
	);
}

export function StyleTagContents()
{
	const siteTheme = (new VenueSettingsFactory()).createSettings(useSite().key,useVenue().settings).siteTheme();

	const paneStyle = () => css({
		width: '100%'
	});

	return (
		<div class={paneStyle()}>
			{/* Label above, not on the left: StylesField stacks the selector and each style's
			    parameter editor vertically, so it needs the full width. */}
			<Wrap label='Styles'>
				<StylesField styleDefinitions={siteTheme.styles} />
			</Wrap>
		</div>
	);
}

